// Fonctionnalités en phase de test (Recouvrement, Procédures, Base de
// connaissance…) : accès limité à quatre personnes. Même liste côté backend
// (backend-myalfa/middleware/accesTesteurs.js), qui seule fait foi.
export const EMAILS_TESTEURS = [
  "nomena@alfa-partenaires.com",
  "jonathan@alfa-partenaires.com",
  "samuel.hoarau@alfacomptabilite.com",
  "anthony.hoarau@alfacomptabilite.com",
];

export const estTesteur = (u) => EMAILS_TESTEURS.includes((u?.email || "").toLowerCase());
